import { render, staticRenderFns } from "./PublicProductList.vue?vue&type=template&id=3782b45e&scoped=true"
import script from "./PublicProductList.vue?vue&type=script&lang=js"
export * from "./PublicProductList.vue?vue&type=script&lang=js"
import style0 from "./PublicProductList.vue?vue&type=style&index=0&id=3782b45e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3782b45e",
  null
  
)

export default component.exports